import { create } from "./create"
import { remove } from "./delete"
import { get } from "./get"
import { update } from "./update"

export const milestones = {
  get,
  create,
  update,
  remove,
}
